<!-- @format -->

<template>
  <div>
    <div class="ui">
      <div class="ui attached message">
        <div class="content">
          <div class="header">Adhoc Cashflows</div>
          <br />

          <div>
            <div class="ui checkbox">
              <input
                type="checkbox"
                v-on:change="switchA"
                v-model="hasAdhocCashFlow"
                name="example"
              />
              <label>Adhoc Withdrawals?</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasAdhocCashFlow" class="ui attached segment">
        <div class="ui form fluid">
          <div class="ui field">
            <label>Age #1</label>
            <input @change="handleChange" v-model.number="adhocCashFlowAge1" />
          </div>
          <div class="ui field">
            <label>
              Adhoc Withdrawal #1
              <small v-if="adhocCashFlowAge1 - currentAge > 0">
                ( R{{
                  formatNr(
                    discounted(adhocCashFlow1, adhocCashFlowAge1 - currentAge)
                  )
                }}
                in today's terms )
              </small>
            </label>
            <currency-input
              @change="handleChange"
              v-model.number="adhocCashFlow1"
              :currency="currency"
            />
          </div>
        </div>
        <div class="ui form fluid">
          <div class="ui field">
            <label>Age #2</label>
            <input @change="handleChange" v-model.number="adhocCashFlowAge2" />
          </div>
          <div class="ui field">
            <label>
              Adhoc Withdrawal #2
              <small v-if="adhocCashFlowAge2 - currentAge > 0">
                ( R{{
                  formatNr(
                    discounted(adhocCashFlow2, adhocCashFlowAge2 - currentAge)
                  )
                }}
                in today's terms )
              </small>
            </label>
            <currency-input
              @change="handleChange"
              v-model.number="adhocCashFlow2"
              :currency="currency"
            />
          </div>
        </div>
      </div>
      <div v-if="!hasAdhocCashFlow" class="ui attached segment">
        No ad-hoc cashflows
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";

import { getIncome } from "@/utils/income.js";
import { GetIncomeCashFlowRequest } from "../utils/income";
import { WithdrawalStrategy } from "../utils/projections";
export default {
  name: "IncomeInput",
  components: { vSelect },
  props: [
    // adhoc
    "currency",
    "shortCurrency",
    "hasAdhocCashFlow",
    "adhocCashFlowAge1",
    "adhocCashFlow1",
    "adhocCashFlowAge2",
    "adhocCashFlow2",
    "adhocCashFlowAge3",
    "adhocCashFlow3",
    "aaType",
  ],
  data() {
    return {
      growthOptions: [
        { value: 1, text: "every year" },
        { value: 2, text: "every 2nd year" },
        { value: 3, text: "every 3rd year" },
        { value: 4, text: "every 4th year" },
        { value: 5, text: "every 5th year" },
        { value: 6, text: "every 6th year" },
        { value: 7, text: "every 7th year" },
        { value: 8, text: "every 8th year" },
        { value: 9, text: "every 9th year" },
        { value: 10, text: "every 10th year" },
      ],
      withdrawalStrategies: [
        {
          value: WithdrawalStrategy.Even,
          text: "Evenly distributed",
        },
        {
          value: WithdrawalStrategy.Custom,
          text: "Custom",
        },
      ],
      payoutFrequencies: [
        { value: 12, text: "per month" },
        { value: 3, text: "per quarter" },
        { value: 1, text: "per annum" },
      ],
    };
  },
  computed: {
    expectedInflationRate() {
      if (this.aaType == "Simple" && this.currency == "ZAR") return 0.055;
      if (this.aaType == "Extended" && this.currency == "ZAR") return 0.05;
      if (this.currency == "USD") return 0.025;

      return 0.055;
    },
  },
  methods: {
    switchA() {
      this.hasAdhocCashFlow != this.hasAdhocCashFlow;
      if (!this.hasAdhocCashFlow) {
        this.adhocCashFlow1 = 0;
        this.adhocCashFlow2 = 0;
      }
      this.handleChange();
    },
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else {
        return numeral(val).format("0,0.0a");
      }
    },
    discounted(val, years) {
      return val / Math.pow(1 + this.expectedInflationRate, years); // finlation adjusted
    },
    handleChange() {
      // construct withdrawal weights
      //let weights = [];

      this.$emit(
        "handleAdhocIncomeChanged",
        new GetIncomeCashFlowRequest({
          currentAge: this.currentAge,

          hasAdhocCashFlow: this.hasAdhocCashFlow,
          adhocCashFlowAge1: this.adhocCashFlowAge1,
          adhocCashFlow1: this.adhocCashFlow1,
          adhocCashFlowAge2: this.adhocCashFlowAge2,
          adhocCashFlow2: this.adhocCashFlow2,
          //  adhocCashFlowAge3: this.adhocCashFlowAge3,
          //  adhocCashFlow3: this.adhocCashFlow3,
        })
      );
    },
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
